import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  announcement: {
    fontSize: "1.5rem",
    fontWeight: "200",
    margin: "auto 10px",
  },
  announcementContainer: {
    display: "flex",
    alignItems: "center",
    alignSelf: "center",
    marginTop: "20px",
    minHeight: "max-content",
  },
});

const Hoy = ({ children, src }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.announcementContainer}>
        <img src={src} alt="_" width="40px" />
        <p className={classes.announcement}>{children}</p>
        <img src={src} alt="_" width="40px" />
      </div>
    </>
  );
};

export default Hoy;
